import { ArrowRight } from "lucide-react";
import SiteNav from "./SiteNav";
import Footer from "@/components/landing/Footer";
import { SiteBookProvider, useSiteBook } from "./SiteBookModal";

// Primary CTA. Book-a-call CTAs (href="/contact") pop the quiz funnel as a modal
// overlay instead of navigating; all other CTAs stay normal links.
// dark=true renders the Skye-style black pill (used on the home hero).
export const SiteCTA = ({ href = "/contact", children, className = "", testId, showArrow = true, dark = false }) => {
  const { openBook } = useSiteBook();
  const cls = `sl-glow-cta group inline-flex cursor-pointer items-center justify-center gap-2 rounded-full ${dark ? "bg-navy" : "bg-brand-gradient"} px-6 py-3.5 font-display text-[15px] font-semibold text-white shadow-pill transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-[0_16px_40px_-10px_rgba(84,87,229,0.55)] active:translate-y-0 ${className}`;
  if (href === "/contact") {
    return (
      <button type="button" onClick={openBook} data-testid={testId} className={cls}>
        <span>{children}</span>
        {showArrow && <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />}
      </button>
    );
  }
  return (
    <a href={href} data-testid={testId} className={cls}>
      <span>{children}</span>
      {showArrow && <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />}
    </a>
  );
};

export const GhostCTA = ({ href, children, className = "", testId }) => (
  <a
    href={href}
    data-testid={testId}
    className={`group inline-flex items-center justify-center gap-2 rounded-full border border-navy/15 bg-white px-6 py-3.5 font-display text-[15px] font-semibold text-navy transition-all duration-300 hover:-translate-y-0.5 hover:border-navy/30 ${className}`}
  >
    <span>{children}</span>
    <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
  </a>
);

export const SiteShell = ({ children, active }) => (
  <div className="App min-h-screen bg-white">
    <SiteBookProvider>
      <SiteNav active={active} />
      <main>{children}</main>
      <Footer />
    </SiteBookProvider>
  </div>
);
